import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { Checkbox, DialogTitle, InputLabel, Tabs, withStyles } from '@material-ui/core/';

export const BButton = styled.button<{ variante?: string }>`

--colore-pieno: ${props => {
	switch (props.variante) {
		case "arancio":
			return "#FFAC00"
		default:
			return "#8820ff"
	}
}};
background-color:var(--colore-pieno);
border:1px solid var(--colore-pieno);
font-size:14px;
color:white;
border-radius:3px;
width:120px;
height:35px;
margin-right:5px;
border:0;
text-align:right;
margin-top:5px;
:hover{
    color:var(--colore-pieno);
    background-color:#ebebef;
    border:1px solid var(--colore-pieno);
}
:active{
    box-shadow: 2px 4px 16px 0 var(--colore-pieno);
}
svg{
    font-size: 20px;
    float:left;
    vertical-align:middle; 
}
`;

export const SButton = styled.button<{ disabled?: boolean, variant?: string, lowercase?: boolean, wordspacing?: boolean }>`
--bg: ${props => {
	if (props.disabled) {
		return "#B5BBBF";
	}

	if (props.variant) {
		switch (props.variant) {
			case "verde":
				return "#008F39"
			case "grigio":
				return "#B5BBBF"
			case "rosso":
				return "#FF0000"
			case "arancio":
				return "#ff8c0d"
			case "secondary":
				return "#D8E4F8"
			default:
				return "#002C74"
		}
	}

	return "#002C74"
}};

--color: ${props => {
	if (props.variant === "secondary") {
		return "#002C74";
	}
	return "#ffffff"
}};

--text: ${props => {
	if (props.lowercase) {
		return "none";
	}
	return "uppercase"
}};

--space: ${props => {
	if (props.wordspacing) {
		return "30px";
	}
	return "normal"
}};

background: var(--bg);
border-radius: 50px;
border: none;
width: 200px;
min-height: 40px;
font-style: normal;
font-size: 18px;
font-weight: bold;
text-align: center;
color: var(--color);
text-transform:  var(--text);
word-spacing: var(--space);
display: flex;
align-items: center;
justify-content: center;
margin-right: 20px;
`;

export const SIconButton = styled.button<{ disabled?: boolean, variant?: string, size?: string }>`
--bg: ${props => {
	if (props.disabled) {
		return "#B5BBBF";
	}

	if (props.variant) {
		switch (props.variant) {
			case "verde":
				return "#008F39"
			case "grigio":
				return "#B5BBBF"
			case "rosso":
				return "#FF0000"
			case "secondary":
				return "#D8E4F8"
			default:
				return "#002C74"
		}
	}
		return "#002C74"
}};

--font-size: ${props => {
	if (props.size) {
		switch (props.size) {
			case "small":
				return "12px"
			default:
				return "18px"
		}
	}
	
	return "18px"
}};

--height: ${props => {
	if (props.size) {
		switch (props.size) {
			case "small":
				return "20px"
			default:
				return "40px"
		}
	}

	return "40px"
}};

--width: ${props => {
	if (props.size) {
		switch (props.size) {
			case "small":
				return "20px"
			default:
				return "40px"
		}
	}

	return "40px"
}};

--padding: ${props => {
	if (props.size) {
		switch (props.size) {
			case "small":
				return "0"
			default:
				return "5px 7px"
		}
	}

	return "5px 7px"
}};

background: var(--bg);
border-radius: 100%;
border: none;
height: var(--height);
width: var(--width);
font-style: normal;
font-size: var(--font-size);
text-align: center;
color: #FFFFFF;
text-transform: uppercase;
word-spacing: 30px;
display: flex;
align-items: center;
justify-content: center;
margin-right: 20px;
padding: var(----padding);
`;

export const STitleContainer = styled.div`
border-bottom: 1px solid #cccccc;
display:flex;
flex-wrap:wrap;
padding:5px 0 5px 0;
margin: 15px 0;
`;

export const SPanelContainer = styled.div`
padding:5px 0 5px 0;
margin: 20px 0;
`;

export const STitleH3 = styled.h3`+
font-style: normal;
font-weight: bold;
font-size: 24px;
line-height: 33px;
text-transform: uppercase;
margin-bottom: 0;
`;

export const STitleH4 = styled.h4`+
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 27px;
display: flex;
align-items: center;
text-transform: uppercase;
margin-bottom: 20px;
color:#002C74;
`;

export const SHomeTitleContainer = styled.div`
margin: 32px 0 40px 0;
`;

export const SSubtitle = styled.p`
font-size:16px;
`;

export const SButtonContainer = styled.div`
display:flex;
flex-wrap:wrap;
padding: 10px 0 10px 0;
margin-bottom: 10px;
`;

export const SMultipleFilterContainer = styled.div`
display:flex;
flex-wrap:wrap;
align-items: flex-end;
padding: 0 0 10px 0;
`;

export const SFilterContainer = styled.div`
margin-right: 20px;
width: 260px;
`;

export const SFilterLabel = styled.label`
margin-top:auto;
margin-bottom:auto;
display: block
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 24px;
color: #373A3C;
margin-bottom: 8px;
`;

export const SFilterInput = styled.input`
background: #FFFFFF;
border: 1px solid #CCCCCC;
box-sizing: border-box;
border-radius: 4px;
padding:5px;
margin-right:5px;
display: block;
width: 100%;
`;

export const SHomeButton = styled(Button)<{ disabled?: boolean }>`
--bg: ${props => {
	switch (props.disabled) {
		case true:
			return "#B5BBBF"
		default:
			return "#002C74"
	}
}};

background-color: var(--bg) !important;
color: #ffffff !important;
border-radius: 20px !important;
text-transform: uppercase !important;
font-weight: bold !important;
font-size: 14px !important;
line-height: 22px !important;
min-height: 69px !important;
// width: 250px !important; 
width: 100% !important; 
`;

export const SLegenda = styled.span`
font-weight: 600;
font-size: 12px;
line-height: 16px;
text-align: right;
letter-spacing: 0.05em;
text-transform: uppercase;
color: #002C74;
`;

export const SDialogTitle = styled(DialogTitle)`
font-weight: bold;
font-size: 16px;
line-height: 33px;
text-transform: uppercase;
`;

export const SDialogSubtitle = styled.p`
font-size:14px;
`;

export const SInputLabel = styled(InputLabel)`
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
width: 80%;
`;

export const SLoginButton = styled(Button)<{ minwidth: number, disabled?: boolean }>`
--mw: ${props => {
	return props.minwidth + '%'
}
}};

--bg: ${props => {
	switch (props.disabled) {
		case true:
			return "#B5BBBF"
		default:
			return "#002C74"
	}
}};
display: inline-block;
border: none;
padding: 10px 15px;
margin: 20px auto 20px auto;
text-decoration: none;
font-weight: bold;
font-size: 1em;
line-height: 1;
cursor: pointer;
text-align: center;
min-width: var(--mw);
display: block;
color: #fff;
$submit-fontcolor-hover: #fff;
background: var(--bg);
//transition: background-color 100ms ease, transform 100ms ease;
-webkit-appearance: none;
-moz-appearance: none;
border-radius: 20px;
&:hover {
	background: #88959e;
	color: #fff;
	box-shadow: 7px 7px 8px #88959e;
}
`;

export const SDialogButton = styled(Button)<{ disabled?: boolean, variantcolor?: string }>`
--bg: ${props => {
	if (props.disabled || props.variantcolor === 'grey') {
		return "#B5BBBF";
	} else if (props.variantcolor === "secondary") {
		return "#D8E4F8";
	} else {
		return "#002C74"
	}
}};

--color: ${props => {
	if (props.variantcolor === "secondary") {
		return "#002C74";
	}else {
		return "#ffffff"
	}
}};
display: inline-block;
border: none;
padding: 10px 15px;
text-decoration: none;
font-weight: bold;
font-size: 1em;
line-height: 1;
text-align: center;
min-width: 150px;
color: var(--color);
$submit-fontcolor-hover: #fff;
background: var(--bg);
-webkit-appearance: none;
-moz-appearance: none;
border-radius: 20px;
&:hover {
	background: #88959e;
	color: #fff;
	box-shadow: 7px 7px 8px #88959e;
}
`;

export const SCheckbox = styled(Checkbox)<{ disabled?: boolean }>`
--color: ${props => {
	if (props?.disabled) {
		return "#B5BBBF"
	} else {
		return "#002C74"
	}
	}
};
color: var(--color) !important;
`;

export const SDangerSubTitle = styled.p`
margin-top: 16px;
color: red;
text-align: center;
text-transform: uppercase;
`;

export const SActivityStatus = styled.span<{ status: string }>`
--bg: ${props => {
	switch (props.status?.toUpperCase()) {
		case "OK":
			return "#008F39"
		case "WAIT":
			return "#B5BBBF"
		case "KO":
			return "#FF0000"
		default:
			return "#B5BBBF"
	}
}};
background-color: var(--bg) !important;
color: #FFFFFF;
border-radius: 50px;
display: block;
width: 120px;
text-align: center;
`;

export const SExtraBackOfficeLabel = styled.p`
background-color: #777777;
color: #ffffff;
text-transform: uppercase;
font-weight: 600;
font-size: 12px;
padding: 3px 10px;
line-height: 16px;
margin-bottom: 0;
`;

export const SUserInfoContainer = styled.div`
padding:5px 0 5px 0;
margin: 15px 0;
`;

export const SUserNameLabel = styled.span`
font-weight: bold;
font-size: 24px;
line-height: 33px;
margin-left: 25px;
`;

export const STitleSpan = styled.span`
font-weight: 600;
font-size: 12px;
line-height: 16px;
color: #002C74;
margin-left: 15px;
display: flex;
align-items: center;
text-transform: uppercase;
`;

export const BHeaderUser = styled.p`
margin: 0 1rem!important;
font-size: 12px !important;
`;

export const BTabsContainer = styled.div`
margin-top: 30px !important;
`;

// export const BTabs = styled.div`
// margin-top: 30px !important;
// `;

export const BTabs = withStyles({
	root: {
		borderBottom: '1px solid #cccccc',
	},
	indicator: {
		backgroundColor: '#002C74',
	},
})(Tabs);

export const BReportLabel = styled.p`
font-size: 16px;
font-weight: bold;
`;
